/* eslint-disable camelcase */
import { legacyPage, page, simplePermission, externalApp, group, legacyTab, tab } from './viewConfigHelpers';

export default {
    tabs: [
        legacyTab('csc_reporting_usage', 'usage')
            .href('#/usage/:menuitem?@:filters')
            .icon('car')
            .headerButtons({ filters: true, incidents: true })
            .get(),
        legacyTab('csc_reporting_quality', 'quality')
            .href('#/quality/:menuitem?@:filters')
            .icon('check-square-o')
            .headerButtons({ filters: true, incidents: true })
            .get(),
        tab('csc_ridehailing_usage', 'rhUsage')
            .href('#/rh-usage/:menuitem?@:filters')
            .icon('taxi')
            .get(),
        tab('csc_p2p_usage', 'p2pUsage')
            .href('#/p2p-usage/:menuitem?@:filters')
            .icon('share-alt-square')
            .get(),
        tab('csc_reporting', 'reporting')
            .href('#/reporting/:menuitem?@:filters')
            .icon('bar-chart')
            .get(),
        tab('csc_demand_prediction', 'demandPrediction')
            .href('#/demand-prediction/:menuitem?')
            .icon('magic')
            .get(),
        legacyTab('csc_operations_fleet', 'fleet')
            .href('#/fleet')
            .icon('globe')
            .template('components/fleet/realtime/fleet.html')
            .headerButtons({ filters: false, incidents: false })
            .get(),
        tab('csc_tasks', 'tasks')
            .href('#/tasks')
            .icon('tasks')
            .get(),
        tab('csc_tasks_mobile', 'tasksMobile')
            .href('#/tasks-mobile')
            .icon('tasks')
            .get(),
        tab('csc_monitoring_dashboard', 'monitoring')
            .href('#/monitoring/:menuitem?')
            .icon('eye')
            .get(),
        tab('csc_external_tools', 'externalTools')
            .href('#/external-tools')
            .icon('wrench')
            .get(),
        tab('csc_rollout', 'rollout')
            .href('#/rollout')
            .externalApp('external_rollout_tool')
            .icon('cloud-upload')
            .get(),
        legacyTab('csc_people', 'people')
            .href('#/people/:menuitem?')
            .icon('users')
            .get(),
        tab('csc_fleet_data', 'fleetData')
            .href('#/fleet-data/:menuitem?')
            .icon('table')
            .get(),
        tab('csc_vehicle_data', 'vehicleData')
            .href('#/vehicle-data/:menuitem?')
            .icon('university')
            .get(),
        tab('rh_trips', 'rhTripsList')
            .href('#/rh-trips-list')
            .icon('taxi')
            .get(),
        legacyTab('csc_p2p_administration', 'p2pAdministration')
            .href('#/p2p/:menuitem?')
            .icon('share-alt')
            .get(),
        tab('external_rentaride_partner_admin', 'rentaridePartnerAdmin')
            .href('#/rentaride-partner-admin')
            .externalApp('external_rentaride_partner_admin')
            .icon('motorcycle')
            .get(),
        tab('external_cslight_vehicles', 'csLightVehicles')
            .href('#/cs-vehicles/:menuitem?')
            .icon('car')
            .get(),
        tab('external_cslight_trips', 'csLightTrips')
            .href('#/cs-trips/:menuitem?')
            .icon('share-alt')
            .get(),
        tab('external_cslight_people', 'csLightPeople')
            .href('#/cs-people/:menuitem?')
            .icon('users')
            .get(),
        tab('external_cslight_service_attributes', 'csLightServiceAttributes')
            .href('#/cs-service-attributes/:menuitem?')
            .icon('sliders')
            .get(),
        tab('log_files_view', 'logFiles')
            .href('#/log-files')
            .externalApp('external_log_files')
            .icon('files-o')
            .get(),
        tab('external_rcv_emea_viewer', 'roadClearance')
            .href('#/road-clearance-viewer')
            .externalApp('external_rcv_emea_viewer')
            .icon('road')
            .get(),
        tab('external_cn_fapiao', 'customerRequests')
            .href('#/cn-fapiao/:menuitem?')
            .icon('weixin')
            .get(),
        tab('external_rmp', 'rmp')
            .href('#/rmp')
            .externalApp('external_rmp')
            .icon('wifi')
            .get(),
        legacyTab('csc_administration', 'administration')
            .href('#/administration/:menuitem?')
            .icon('gears')
            .get(),
        tab('teleop', 'teleoperations')
            .href('#/teleop/:menuitem?')
            .icon('space-shuttle')
            .get(),
        tab('csc_feedback', 'feedback')
            .icon('commenting')
            .options({ menuComponent: 'FeedbackPanel' })
            .get()
    ],

    menus: {
        csc_reporting_usage: [
            group('Registration', [
                legacyPage('kpi_number_active_vehicles', 'Number of Active Vehicles')
                    .template('components/kpis/kpi_number_active_vehicles/kpiNumberActiveVehicles.html')
                    .showSidebar()
                    .get()
            ]),

            group('Reservation', [
                legacyPage('kpi_ratio_bookings_reservations', 'Ratio Bookings to Reservations')
                    .template('components/kpis/kpi_ratio_bookings_reservations/kpiRatioBookingsReservations.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_availability', 'Vehicles not Available')
                    .template('components/kpis/kpi_availability/kpiAvailability.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_reservation_time_used', 'Reservation Time Used')
                    .template('components/kpis/reservationTime/reservationTime.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_reservation_time_to_cancel', 'Reservation Time to Cancel')
                    .template('components/kpis/reservationTime/reservationTime.html')
                    .showSidebar()
                    .get()
            ]),

            group('Open Vehicle', [
                legacyPage('kpi_access_type', 'Access Type')
                    .template('components/kpis/kpi_access_type/kpiAccessType.html')
                    .sidebar('components/kpis/kpi_access_type/kpiAccessTypeSettings.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_access_type_duration', 'Duration to Open Vehicle')
                    .template('components/kpis/kpi_access_type_duration/kpiAccessTypeDuration.html')
                    .sidebar('components/kpis/kpi_access_type_duration/kpiAccessTypeDurationSettings.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_customer_handshake', 'Customer Handshake')
                    .template('components/kpis/kpi_customer_handshake/kpiCustomerHandshake.html')
                    .disabledFilters([
                        'weekDays',
                        'timeIntervals',
                        'clientVersions',
                        'carModels',
                        'softwareVersions',
                        'fuelTypes',
                        'gearTypes'
                    ])
                    .showSidebar()
                    .get()
            ]),

            group('Booking Start', [
                legacyPage('kpi_number_of_bookings', 'Number of Bookings')
                    .template('components/kpis/utilizationDimensions/utilizationDimensions.html')
                    .sidebar('components/kpis/utilizationDimensions/utilizationDimensionsSettings.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_start_booking_timestamp', 'Booking Start Time')
                    .template('components/kpis/kpi_start_booking_timestamp/kpiStartBookingTimestamp.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_bootup_time', 'Boot Up Time')
                    .template('components/kpis/kpi_bootup_time/kpiBootupTime.html')
                    .sidebar('components/kpis/kpi_bootup_time/kpiBootupTimeSettings.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_packages_usage', 'Packages')
                    .template('components/kpis/kpi_packages_usage/kpiPackagesUsage.html')
                    .showSidebar()
                    .get()
            ]),

            group('Drive', [
                legacyPage('kpi_vehicle_utilization', 'Vehicle Utilization')
                    .template('components/kpis/drive/drive.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_duration_ride', 'Booking Duration')
                    .template('components/kpis/drive/drive.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_driving_distance', 'Driven Distance')
                    .template('components/kpis/drive/drive.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_parking_sessions', 'Parking Sessions')
                    .template('components/kpis/drive/drive.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_drive_parking_duration', 'Duration of Parking Sessions')
                    .template('components/kpis/drive/drive.html')
                    .showSidebar()
                    .get()
            ]),

            group('Parking', [
                page('parking_violations', 'Parking Violations')
                    .headerButtons({ filters: false, incidents: false })
                    .get(),
                page('parking_report', 'Parking Report')
                    .headerButtons({ filters: false, incidents: false })
                    .get(),

                simplePermission('parking_stat_sunday', 'Parking Statistics (Sunday)'),
                simplePermission('parking_stat_zero_am_to_six_am', 'Parking Statistics (0 - 6am)'),
                simplePermission('parking_stat_six_am_to_nine_am', 'Parking Statistics (6 - 9am)')
            ]),

            group('Booking End', [
                legacyPage('kpi_vehicle_idle_time', 'Vehicle Idle Time')
                    .template('components/kpis/kpi_vehicle_idle_time/kpiVehicleIdleTime.html')
                    .sidebar('components/kpis/kpi_vehicle_idle_time/kpiVehicleIdleTimeSettings.html')
                    .showSidebar()
                    .get()
            ]),

            group('Billing', [
                legacyPage('kpi_billed_utilization', 'Billed Utilization')
                    .template('components/kpis/kpi_billed_utilization/kpiBilledUtilization.html')
                    .showSidebar()
                    .get()
            ])
        ],

        csc_ridehailing_usage: [
            group('Driver', [
                page('rh_kpi_driver_availability', 'Availability').get(),
                page('rh_kpi_driver_rating', 'Rating').get(),
                page('rh_kpi_driver_trips', 'Driver Trip').get(),
                page('rh_kpi_shift_fulfillment', 'Shift').get()
            ]),

            group('Driver Vendor', [
                page('rh_kpi_driver_vendor_performance', 'Driver Performance').get(),
                page('rh_kpi_supply_plan', 'Supply Plan').get()
            ]),

            page('rh_kpi_number_of_trips', 'Trip').get(),

            group('Supply & Demand', [
                page('rh_kpi_sd', 'Supply & Demand').get(),
                page('rh_kpi_relocations', 'Relocation').get(),
                page('rh_kpi_drop_offs_pick_ups', 'Drop-Offs & Pick-Ups').get()
            ]),

            page('rh_kpi_members', 'Members').get(),
            page('rh_kpi_costs', 'Costs').get(),
            page('rh_kpi_revenue', 'Revenue').get()
        ],

        csc_p2p_usage: [
            group('Trip', [
                page('p2p_kpi_trips_per_peer', 'Trips per Peer').get(),
                page('p2p_kpi_trip_confirmation', 'Lead Time Trip Confirmation (Non-VIP Peer)').get(),
                page('p2p_kpi_reservation_time', 'Reservation Time').get(),
                page('p2p_kpi_trip_time', 'Trip Time').get(),
                page('p2p_kpi_driven_kilometers', 'Driven Kilometers').get(),
                page('p2p_kpi_calculated_cost', 'Calculated Cost').get(),
                page('p2p_kpi_cancelled_trips_peer', 'Cancelled Trips by Peer').get(),
                page('p2p_kpi_cancelled_trips_owner', 'Cancelled Trips by Owner').get(),
                page('p2p_kpi_overdue_bookings', 'Overdue Bookings').get(),
                page('p2p_kpi_conducted_trips', 'Conducted and Not Conducted Trips').get()
            ]),

            group('Member', [
                page('p2p_kpi_registered_owners', 'Total Registered Owners').get(),
                page('p2p_kpi_registered_peers', 'Total Registered Peers').get(),
                page('p2p_kpi_invited_peers', 'Invited Peers per Owner').get(),
                page('p2p_kpi_active_peers', 'Active Peers per Owner').get(),
                page('p2p_kpi_peers_per_owner', 'Registered Peers per Owner').get(),
                page('p2p_kpi_vip_peers', 'VIP Peers vs. Non-VIP Peers').get()
            ])
        ],

        csc_reporting: [
            group('Utilization', [
                page('reporting_kpi_driven_distance', 'Driven distance', ['CS']).get(),
                page('reporting_kpi_driving_time', 'Driving time', ['CS']).get(),
                page('reporting_kpi_engine_running_time', 'Engine running time', ['CS']).get(),
                page('reporting_kpi_fuel_consumption', 'Fuel consumption', ['CS']).get(),
                page('reporting_kpi_refueling_events', 'Refueling events', ['CS']).get(),
                page('reporting_kpi_door_events', 'Door events', ['CS']).get()
            ])
        ],

        csc_reporting_quality: [
            legacyPage('kpi_network_issues', 'Network Issues')
                .template('components/kpis/kpi_network_issues/kpiNetworkIssues.html')
                .sidebar('components/kpis/kpi_network_issues/kpiNetworkIssuesSettings.html')
                .showSidebar()
                .get(),
            legacyPage('kpi_disconnected_vehicles', 'Disconnected Vehicles')
                .template('components/kpis/kpi_disconnected_vehicles/kpiDisconnectedVehicles.html')
                .showSidebar()
                .get(),

            group('Error Analyses', [
                legacyPage('kpi_errors', 'Errors')
                    .template('components/kpis/restartsErrors/restartsErrors.html')
                    .sidebar('components/kpis/restartsErrors/restartsErrorsSettings.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_error_classification', 'USB Detached')
                    .template('components/kpis/errorClassification/errorClassification.html')
                    .sidebar('components/kpis/errorClassification/errorClassificationSettings.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_error_bookings', 'Bookings with USB Detached')
                    .template('components/kpis/errorClassification/errorBookings.html')
                    .sidebar('components/kpis/errorClassification/errorClassificationSettings.html')
                    .showSidebar()
                    .get(),
                legacyPage('kpi_startup_errors', 'StartUp Event')
                    .template('components/kpis/kpi_startup_errors/kpiStartUpErrors.html')
                    .sidebar('components/kpis/kpi_startup_errors/kpiStartUpErrorsSettings.html')
                    .showSidebar()
                    .get()
            ]),

            legacyPage('kpi_exceptions', 'Exceptions')
                .template('components/kpis/restartsErrors/restartsErrors.html')
                .sidebar('components/kpis/restartsErrors/restartsErrorsSettings.html')
                .showSidebar()
                .get(),
            legacyPage('kpi_outside_reader_configuration', 'Outside Reader')
                .template('components/kpis/kpi_outside_reader_configuration/kpiOutsideReaderConfiguration.html')
                .sidebar('components/kpis/kpi_outside_reader_configuration/kpiOutsideReaderConfigurationSettings.html')
                .showSidebar()
                .get(),
            legacyPage('kpi_rmp_commands', 'RMP Commands')
                .template('components/kpis/kpi_rmp_commands/kpiRMPCommands.html')
                .sidebar('components/kpis/kpi_rmp_commands/kpiRMPCommandsSettings.html')
                .showSidebar()
                .kpiFilterDateIncludeToday()
                .get(),
            legacyPage('kpi_fleet_health_record', 'Fleet Health Record')
                .template('components/kpis/kpi_fleet_health_record/kpiFleetHealthRecord.html')
                .sidebar('components/kpis/kpi_fleet_health_record/kpiFleetHealthRecordSettings.html')
                .showSidebar()
                .get(),
            page('kpi_vin_health_record', 'Vehicle Health Record')
                .headerButtons({ filters: false, incidents: false })
                .get(),
            legacyPage('log_analyzer', 'Logs and Event Analyzer')
                .template('components/logAnalyzer/logAnalyzer.html')
                .headerButtons({ filters: false })
                .get(),
            legacyPage('kpi_software_rollout_status', 'Rollout Status/History')
                .template('components/kpis/kpi_software_rollout_status/kpiSoftwareRolloutStatus.html')
                .sidebar('components/kpis/kpi_software_rollout_status/kpiSoftwareRolloutStatusSettings.html')
                .showSidebar()
                .headerButtons({ filters: true, incidents: true })
                .disabledFilters(['weekDays', 'clientVersions', 'carModels', 'softwareVersions', 'fuelTypes', 'gearTypes'])
                .kpiFilterDateIncludeToday()
                .get()
        ],

        csc_demand_prediction: [page('cs_demand_prediction', 'CS Demand Prediction').get()],

        csc_operations_fleet: [
            simplePermission('fleet_rmp', 'RMP'),
            simplePermission('fleet_vin_health_record', 'Vehicle Health Record (requires KPI permission)'),
            simplePermission('fleet_vehicle_other_data', 'Additional data in vehicle details view'),
            simplePermission('fleet_vehicle_alert_list', 'Vehicle alert list'),
            simplePermission('gps_positions_all', 'All GPS positions visible'),
            simplePermission('gps_positions_not_booked', 'GPS positions not booked visible'),
            simplePermission('gps_positions_parked_in_statistic_zone', 'GPS Positions parked in zone visible'),
            simplePermission('extended_vehicle_information_no_gps', 'All vehicle information except GPS'),
            simplePermission('control_parking_behavior', 'Manually start/stop paid parking processes'),
            simplePermission('fleet_vehicle_battery_health_data', 'Low voltage battery health'),
            simplePermission('fleet_delete_relocations', 'Delete relocations'),
            simplePermission('rh_trips_manage', 'Manage RH trips'),
            simplePermission('stateless_live_data_updates', 'Stateless Live Vehicle Data')
        ],

        csc_tasks: [simplePermission('tooltask_view', 'Task View'), simplePermission('tooltask_manage', 'Task Manage')],

        csc_monitoring_dashboard: [
            group('Client events based', [
                page('monitoring_client_events_statistics_client_events_based', 'Client events statistics').get(),
                page('monitoring_network_statistics_client_events_based', 'Network statistics').get()
            ]),

            group('CSBE based', [
                page('monitoring_reservations_statistics_csbe_based', 'Reservations statistics').get(),
                page('monitoring_bookings_statistics_csbe_based', 'Bookings statistics').get(),
                page('monitoring_rmp_statistics_csbe_based', 'RMP statistics (CSBE based)').get(),
                page('monitoring_execution_times_statistics_csbe_based', 'Execution times statistics').get(),
                page('monitoring_software_updates_and_provisionings_csbe_based', 'Software updates & provisionings').get(),
                page('monitoring_occurred_technical_problems_csbe_based', 'Occurred technical problems').get()
            ]),

            page('monitoring_rmp_statistics', 'RMP statistics').get(),
            page('monitoring_vehicle_business_states', 'Vehicle business states').get()
        ],

        csc_rollout: [
            simplePermission('assemble_csm3_stateful', 'Assemble CS3 Stateful'),
            simplePermission('assemble_csm4_stateful', 'Assemble CS4 Stateful'),
            simplePermission('assemble_csm3_stateless', 'Assemble CS3 Stateless'),

            simplePermission('rollout_techonly_infleeting_software', 'TechOnly Infleeting Software'),
            simplePermission('rollout_techonly_available_packages', 'TechOnly Available Packages'),
            simplePermission('rollout_stateless_update_api', 'Stateless Update API'),
            simplePermission('rollout_target_versions', 'Target versions'),
            simplePermission('rollout_field_test_vins', 'Field test VINs'),
            simplePermission('rollout_special_vins', 'Special VINs'),
            simplePermission('rollout_tags', '#Tags')
        ],

        csc_administration: [
            page('administration_user_preferences', 'User Preferences').get(),
            page('administration_users', 'User Permissions').get(),
            page('administration_groups', 'Group Permissions').get(),
            page('administration_manage_permissions', 'Manage Permissions').get(),
            page('administration_messages', 'Messages').get(),
            page('administration_manage_notifications', 'Manage Notifications').get(),

            simplePermission('rh_trip_notifications_view', 'View RH Trip Notifications'),
            simplePermission('rh_trip_notifications_manage', 'Manage RH Trip Notifications'),

            group('Tasks', [
                page('administration_alert_settings', 'Configuration').get(),
                page('administration_alert_notifications', 'My Notifications').get(),
                page('administration_task_assignees', 'Task assignees').get()
            ]),

            group('Zones Administration', [
                legacyPage('administration_special_zones', 'Special Zone Administration')
                    .template('components/administration/zones/views/zones.html')
                    .get(),
                legacyPage('administration_no_fly_zones', 'No-Fly Zone Administration')
                    .template('components/administration/zones/views/zones.html')
                    .get(),
                legacyPage('administration_mobility_stations', 'Mobility Station Administration')
                    .template('components/administration/zones/views/mobilityStations.html')
                    .get(),
                page('administration_parking_zones', 'Parking Zone Administration').get()
            ])
        ],

        csc_people: [
            simplePermission('external_odm_access_control_manage', 'Manage ODM Access Control'),
            simplePermission('external_odm_member_ces', 'CES Member Manage'),
            simplePermission('people_driver_supply_plan_driver_vendor', 'Supply plan view for driver vendor'),
            simplePermission('people_driver_supply_plan_driver_manager', 'Supply plan view for driver manager'),

            group('Drivers', [
                externalApp('external_driver_cn_core', 'Core data'),
                legacyPage('people_driver_supply_plan', 'Supply plan')
                    .template('components/people/drivers/supplyPlan/supplyPlan.html')
                    .get(),
                externalApp('external_driver_shifts', 'Shifts'),

                externalApp('people_driver_shift_mgmt', 'Driver Management'),
                externalApp('people_driver_mgmt', 'Driver Shift Management')
            ]),

            group('Member', [
                externalApp('external_member_emea_core', 'EMEA Core Data'),
                externalApp('external_member_cn_core', 'CN Core Data'),
                externalApp('external_member_invoices', 'CN Invoices'),
                externalApp('external_urban_pilot', 'Urban Pilot'),

                externalApp('people_customer_mgmt', 'Customer Management'),

                // Permissions for external apps
                simplePermission('member_view', 'Member view'),
                simplePermission('member_manage', 'Member view manage'),
                simplePermission('driver_view', 'Driver view'),
                simplePermission('driver_manage', 'Driver view manage'),
                simplePermission('member_invoices_view', 'Invoice view'),
                simplePermission('member_invoice_manage', 'Invoice view manage'),
                simplePermission('member_coupons_view', 'Coupon view'),
                simplePermission('member_coupons_manage', 'Coupon view manage'),
                simplePermission('supply_plan_upload', 'Supply plan upload'),
                simplePermission('driver_shifts', 'Driver shift view'),
                simplePermission('emea_profiles', 'EMEA Users'),
                simplePermission('emea_profiles_private', 'EMEA Users Private'),
                simplePermission('cn_profiles', 'CN Users'),
                simplePermission('cn_profiles_private', 'CN Users Private'),
                simplePermission('emea_p2p_es_owner', 'P2P ES Owner'),
                simplePermission('emea_p2p_es_peer', 'P2P ES Peer'),
                simplePermission('emea_p2p_es_dealer', 'P2P ES Dealer'),
                simplePermission('cn_rh_ctu_member', 'RH CTU Member Core'),
                simplePermission('cn_rh_ctu_member_private', 'RH CTU Member Private'),
                simplePermission('cn_rh_ctu_b2b', 'RH CTU B2B'),
                simplePermission('cn_rh_ctu_b2b_private', 'RH CTU B2B Private'),
                simplePermission('cn_rh_ctu_driver', 'RH CTU Driver Core'),
                simplePermission('cn_rh_ctu_driver_private', 'RH CTU Driver Private'),
                simplePermission('external_urban_pilot_users_view', 'Urban Pilot Users view'),
                simplePermission('external_urban_pilot_users_manage', 'Urban Pilot Users manage')
            ])
        ],

        csc_p2p_administration: [
            legacyPage('p2p_administration', 'P2P Administration')
                .template('components/administration/p2p/trips.html')
                .get(),
            page('p2p_test_bookings', 'P2P Test Bookings').get(),
            page('p2p_administration_v2', 'P2P Administration ( V2 )').get()
        ],

        csc_fleet_data: [
            externalApp('external_fleet_data_operator', 'Operator Administration'),
            externalApp('external_fleet_data_subsidiary', 'Subsidiary Administration'),
            externalApp('external_fleet_data_fleet', 'Fleet Administration'),
            page('administration_fleets_view', 'Fleet Configuration').get(),
            simplePermission('administration_fleets_create', 'Fleets Create'),
            simplePermission('administration_fleets_update_delete', 'Fleets Update & Delete'),
            simplePermission('fleet_master_admin', 'Fleet Master Admin')
        ],

        csc_vehicle_data: [
            externalApp('external_vehicle_data', 'Core Data'),
            page('administration_vehicle_display_view', 'Displayed Data').get(),
            externalApp('external_vehicle_billing_data', 'Vehicle Billing Data'),
            // Permissions for external apps
            simplePermission('vehicle_view', 'Vehicle view'),
            simplePermission('vehicle_manage', 'Vehicle view manage'),
            simplePermission('administration_vehicle_display_manage', 'Displayed Data manage'),
            page('vehicletags_view', 'Vehicle Tag View').get(),
            simplePermission('vehicletags_manage', 'Vehicle Tag Management'),
            page('vehicletags_assignment_view', 'Vehicle Tag Assignment View').get()
        ],

        external_cslight_vehicles: [
            externalApp('external_cslight_emea_vehicle_data', 'CS - Vehicle Data'),
            externalApp('external_cslight_emea_vehicle_groups', 'CS - Vehicle Groups'),
            externalApp('external_cslight_emea_damage_management', 'CS - Damage Management')
        ],
        external_cslight_trips: [
            externalApp('external_cslight_emea_calender', 'CS - Trip Calendar'),
            externalApp('external_cslight_emea_summary', 'CS - Summary')
        ],
        external_cslight_people: [externalApp('external_cslight_emea_drivers', 'CS - Drivers')],
        external_cslight_service_attributes: [
            externalApp('external_cslight_emea_stations', 'CS - Stations'),
            externalApp('external_cslight_emea_trip_parameter', 'CS - Trip-parameters'),
            externalApp('external_cslight_emea_tariffs', 'CS - Tariffs')
        ],
        log_files_view: [
            simplePermission('log_files_write_csm3_manual', 'Log Files write CSM3 manual'),
            simplePermission('log_files_read_csm3_manual', 'Log Files read CSM3 manual'),
            simplePermission('log_files_read_csm3', 'Log Files read CSM3'),
            simplePermission('log_files_read_csm4', 'Log Files read CSM4'),
            simplePermission('log_files_read_csm4r', 'Log Files read CSM4R'),
            simplePermission('log_files_read_csm5', 'Log Files read CSM5'),
            simplePermission('log_files_read_demoapp_techonly_ios', 'Log Files read App iOS'),
            simplePermission('log_files_read_demoapp_techonly_android', 'Log Files read App Android')
        ],
        external_rcv_emea_viewer: [simplePermission('external_rcv_emea_editor', 'Road Clearance Viewer Edit')],
        external_cn_fapiao: [
            group('Customer requests', [
                externalApp('external_cn_fapiao_overview', 'Fapiaos'),
                externalApp('external_cn_fapiao_complaints', 'Complaints')
            ])
        ],
        external_rmp: [
            simplePermission('external_rmp_low_security_commands', 'Low Security Commands'),
            simplePermission('external_rmp_mid_security_commands', 'Mid Security Commands'),
            simplePermission('external_rmp_high_security_commands', 'High Security Commands'),
            simplePermission('external_rmp_bulk_commands', 'Bulk Commands')
        ],
        teleop: [
            simplePermission('teleop_tasks_view', 'Tasks View'),
            simplePermission('teleop_tasks_manage', 'Tasks Manage'),
            group('Tasks', [externalApp('teleop_tasks_ongoing', 'Ongoing Tasks'), externalApp('teleop_tasks_archive', 'Tasks Archive')]),
            group('Sessions', [
                externalApp('teleop_sessions_ongoing', 'Ongoing Sessions'),
                externalApp('teleop_sessions_archive', 'Sessions Archive')
            ])
        ]
    },

    // Views that are neither tabs nor have submenus
    additional: [
        simplePermission('csc_calendar', 'Incidents'),
        simplePermission('csc_fuel_truck_pilot', 'Fuel truck pilot (Mobile Cockpit)'),
        simplePermission('csc_onsite_agent', 'On-site agent (Mobile Cockpit)'),
        simplePermission('csc_odm', 'Vehicle position app (deprecated)'),
        simplePermission('csc_access_admin_security_audit', 'Access Admin Security Audit'),
        simplePermission('csc_access_security_audit_view', 'Access Security Audit View'),
        simplePermission('csc_access_security_audit_report', 'Access Security Audit Report')
    ]
};
